// Import .less entry point
import '../assets/private/stylesheets/create-account/_create-account.less';
import './customer/styles/style';

import { init as initCustomerPassword } from './customer/customer-password';
import { init as initCreateAccount } from './customer/create-account/create-account';
import { init as initCreateAccountLoyaltySubscription } from './customer/create-account/create-account-loyalty-subscription';
import { init as initCreateAccountTooltip } from './customer/create-account/create-account-tooltip';


export const init = () => {
  const form = cube.$id('js-create-account-form');

  if (form) initCreateAccount(form);
  if (cube.$('.js-password')) initCustomerPassword();
  if (cube.$id('create-account-loyalty-subscription')) initCreateAccountLoyaltySubscription();
  if (cube.$id('remember-me-tooltip')) initCreateAccountTooltip();
};

document.addEventListener('DOMContentLoaded', init);



// WEBPACK FOOTER //
// ./src/create-account.route.js